import React from 'react';
import LazyLoad from 'react-lazyload';

import Image, { ImageProps } from '@tb-core/components/ui/image';

export interface LazyLoadImageProps extends ImageProps {
    height?: string;
}

const LazyLoadImage = ({
    height = '100%',
    src = null,
    ...props
}: LazyLoadImageProps) => (
    <LazyLoad height={height}>
        <Image {...props} src={src} />
    </LazyLoad>
);

export default LazyLoadImage;
